const acceptedImageTypes = [
    { type: 'image/svg+xml', label: 'SVG', extensions: '.svg' },
    { type: 'image/png', label: 'png', extensions: '.png' },
    { type: 'image/webp', label: 'webp', extensions: '.webp' },
    { type: 'image/jpeg', label: 'jpeg', extensions: '.jpeg,.jpg' },
];

const maxImageSize = 8_000_000; // 8Mo

const DEFAULT_CAMERA_ANIMATION_DURATION = 750;
// Share of the tighter canvas axis the print surface spans in the default
// view. The remainder is breathing margin, so the whole working zone stays
// visible with a little room around it.
const ZOOM_DEFAULT_SURFACE_RATIO = 0.92;
// Zoom bounds, as multiples of the default view. Expressed as ratios rather
// than raw canvas zooms so they stay independent of the viewport size and of
// the print DPI — a raw bound means a different framing on every screen.
const ZOOM_MIN_RATIO = 0.5;
const ZOOM_MAX_RATIO = 4;
// Applied per click on the zoom in / out buttons.
const ZOOM_STEP_RATIO = 1.2;
// Extra panning slack on each side, as a share of the viewport. At 0.5 any edge
// of the design can be brought to the centre of the screen — which is what you
// need to zoom in on a border comfortably. Raising it past 0.5 starts letting
// the design leave the screen entirely.
const PAN_MARGIN_RATIO = 0.5;

// The 3D camera frames the product at a distance factor, so SMALLER is closer.
// Bounds and step mirror the 2D viewport: one default, hard limits, a constant
// step. They stay inside the orbit controls' own min/max distance, so a button
// reports its limit at the moment the camera actually stops moving.
const ZOOM_3D_DEFAULT_FACTOR = 1.1;
const ZOOM_3D_MIN_FACTOR = 0.5;
const ZOOM_3D_MAX_FACTOR = 1.5;
const ZOOM_3D_STEP_RATIO = 1.2;

const THROTTLE_TOUCH_TIMING = 8; // 8ms for touch (~120fps)
const THROTTLE_MOUSE_TIMING = 16; // 16ms for mouse (~60fps)

const BUTTON_GAP_MOBILE = 30; // Smaller gap on mobile
const BUTTON_GAP_DESKTOP = 50; // Default gap on desktop
const TRIGGER_AREA_MOBILE = 80; // Smaller trigger area on mobile
const TRIGGER_AREA_DESKTOP = 250; // Default trigger area on desktop

const MOBILE_BREAKPOINT = 768; // Define a breakpoint for mobile devices

export {
    acceptedImageTypes,
    BUTTON_GAP_DESKTOP,
    BUTTON_GAP_MOBILE,
    DEFAULT_CAMERA_ANIMATION_DURATION,
    maxImageSize,
    MOBILE_BREAKPOINT,
    PAN_MARGIN_RATIO,
    THROTTLE_MOUSE_TIMING,
    THROTTLE_TOUCH_TIMING,
    TRIGGER_AREA_DESKTOP,
    TRIGGER_AREA_MOBILE,
    ZOOM_3D_DEFAULT_FACTOR,
    ZOOM_3D_MAX_FACTOR,
    ZOOM_3D_MIN_FACTOR,
    ZOOM_3D_STEP_RATIO,
    ZOOM_DEFAULT_SURFACE_RATIO,
    ZOOM_MAX_RATIO,
    ZOOM_MIN_RATIO,
    ZOOM_STEP_RATIO,
};
